import React from 'react';
import { colorAccessibleGreen, colorCardinal, colorRajahDark, colorGreyShark } from '@tds/core-colours';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getCopy, safeRest, pixelToRem } from '@tds/util-helpers';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

/* eslint-disable import/prefer-default-export */
var warn = function warn(componentName, message) {
  if (process.env.NODE_ENV === 'production') {
    return;
  }

  console.warn("[TDS] ".concat(componentName, ": ").concat(message)); // eslint-disable-line no-console
};

var StyledSVG = styled.svg.withConfig({
  displayName: "FeedbackIcon__StyledSVG",
  componentId: "sc-1swr281-0"
})(function (_ref) {
  var width = _ref.width,
      height = _ref.height;
  return {
    width: "".concat(width, "rem"),
    height: "".concat(height, "rem")
  };
});
/**
 * @version ./package.json
 */

var FeedbackIcon = function FeedbackIcon(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      copy = _ref2.copy,
      copyDictionary = _ref2.copyDictionary,
      optionalText = _ref2.optionalText,
      children = _ref2.children,
      rest = objectWithoutProperties(_ref2, ["width", "height", "copy", "copyDictionary", "optionalText", "children"]);

  if (rest.onClick) {
    warn('FeedbackIcon', 'FeedbackIcons are not meant to be interactive, do not pass an onClick handler.');
  }

  var a11yText = getCopy(copyDictionary, !optionalText ? copy || 'en' : copy).a11yText;

  if (!optionalText && a11yText === '') {
    warn('FeedbackIcon', 'The `copy` prop is required, please provide some copy by supplying an object with `a11yText` as a key and your copy as a value.');
  }

  return React.createElement(StyledSVG, _extends_1({}, safeRest(rest), {
    role: "img",
    "aria-hidden": a11yText === '' ? true : undefined,
    width: pixelToRem(width),
    height: pixelToRem(height)
  }), a11yText && React.createElement("title", null, a11yText), children);
};

FeedbackIcon.propTypes = {
  /**
   * Use the copy prop to either select provided English or French copy
   * by passing `'en'` or `'fr'` respectively.
   *
   * To provide your own, pass a JSON object with the key `a11yText`.
   */
  copy: PropTypes.oneOfType([PropTypes.oneOf(['en', 'fr']), PropTypes.shape({
    a11yText: PropTypes.string.isRequired
  })]).isRequired,

  /** @ignore */
  copyDictionary: PropTypes.object,

  /** @ignore */
  optionalText: PropTypes.bool,

  /** @ignore */
  children: PropTypes.node.isRequired,

  /** @ignore */
  width: PropTypes.number.isRequired,

  /** @ignore */
  height: PropTypes.number.isRequired
};
FeedbackIcon.defaultProps = {
  optionalText: false,
  copyDictionary: {}
};

var Checkmark = function Checkmark(props) {
  return React.createElement(FeedbackIcon, _extends_1({
    copy: {
      a11yText: ''
    }
  }, props, {
    optionalText: true,
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }), React.createElement("path", {
    fill: colorAccessibleGreen,
    fillRule: "evenodd",
    d: "M5.807 13.072a.592.592 0 0 1-.091.106l-.026.024-.1.112a.545.545 0 0 1-.433.185.581.581 0 0 1-.453-.204L1.159 9.2a.677.677 0 0 1 .014-.888.55.55 0 0 1 .812 0l3.155 3.382 8.872-9.512a.548.548 0 0 1 .816.002c.226.242.23.636.009.881l-9.03 10.008z"
  }));
};

Checkmark.displayName = 'Checkmark';

var Times = function Times(props) {
  return React.createElement(FeedbackIcon, _extends_1({
    copy: {
      a11yText: ''
    }
  }, props, {
    optionalText: true,
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }), React.createElement("path", {
    fill: colorCardinal,
    fillRule: "evenodd",
    d: "M8 9.17l-4.931 4.637a.756.756 0 0 1-1.034-.021l.176.175a.718.718 0 0 1-.003-1.012l4.781-4.782a40.59 40.59 0 0 1-.083-.085l-4.72-5.017a.753.753 0 0 1 .03-1.03l-.176.177a.714.714 0 0 1 1.012-.003L8 7.157l4.948-4.948a.714.714 0 0 1 1.012.003l-.176-.176a.753.753 0 0 1 .03 1.029l-4.72 5.017a40.59 40.59 0 0 1-.083.085l4.781 4.782a.718.718 0 0 1-.003 1.012l.176-.175a.756.756 0 0 1-1.034.021L8 9.17z"
  }));
};

Times.displayName = 'Times';

var copyDictionary = {
  en: {
    a11yText: 'Success'
  },
  fr: {
    a11yText: 'Réussite'
  }
};

var NotificationSuccess = function NotificationSuccess(props) {
  return React.createElement(FeedbackIcon, _extends_1({}, props, {
    copyDictionary: copyDictionary,
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }), React.createElement("path", {
    fill: colorAccessibleGreen,
    fillRule: "evenodd",
    d: "M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10zm8.127 4.673a.633.633 0 0 0 .092-.105l7.734-8.572a.693.693 0 0 0-.009-.925.595.595 0 0 0-.882-.001l-7.514 8.055-2.612-2.8a.596.596 0 0 0-.88 0 .706.706 0 0 0-.014.928l3.038 3.51a.623.623 0 0 0 .486.219.587.587 0 0 0 .46-.2l.087-.097.014-.012z"
  }));
};

NotificationSuccess.displayName = 'NotificationSuccess';

var copyDictionary$1 = {
  en: {
    a11yText: 'Warning'
  },
  fr: {
    a11yText: 'Avertissement'
  }
};

var NotificationWarning = function NotificationWarning(props) {
  return React.createElement(FeedbackIcon, _extends_1({}, props, {
    copyDictionary: copyDictionary$1,
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }), React.createElement("path", {
    fill: colorRajahDark,
    fillRule: "evenodd",
    d: "M10.878 1.61l8.315 15.244a1 1 0 0 1-.878 1.48H1.685a1 1 0 0 1-.878-1.48L9.122 1.61a1 1 0 0 1 1.756 0zM10 16.794c.46 0 .833-.402.833-.898 0-.495-.373-.897-.833-.897-.46 0-.833.402-.833.897 0 .496.373.898.833.898zm-.022-2.885c.347 0 .63-.297.64-.67l.179-6.698c.01-.388-.28-.709-.64-.709h-.35c-.361 0-.65.32-.64.708l.171 6.699c.01.373.294.67.64.67z"
  }));
};

NotificationWarning.displayName = 'NotificationWarning';

var copyDictionary$2 = {
  en: {
    a11yText: 'Error'
  },
  fr: {
    a11yText: 'Erreur'
  }
};

var NotificationError = function NotificationError(props) {
  return React.createElement(FeedbackIcon, _extends_1({}, props, {
    copyDictionary: copyDictionary$2,
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }), React.createElement("path", {
    fill: colorCardinal,
    fillRule: "evenodd",
    d: "M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10zm10 5.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666zm-.003-2.5c.354 0 .644-.306.654-.69l.182-6.912c.01-.4-.285-.731-.654-.731H9.82c-.369 0-.664.33-.654.73l.175 6.912c.01.385.3.691.655.691z"
  }));
};

NotificationError.displayName = 'NotificationError';

var copyDictionary$3 = {
  en: {
    a11yText: 'Add location'
  },
  fr: {
    a11yText: 'Ajouter un emplacement'
  }
};

var LocationAdd = function LocationAdd(props) {
  return React.createElement(FeedbackIcon, _extends_1({}, props, {
    copyDictionary: copyDictionary$3,
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }), React.createElement("path", {
    fill: colorGreyShark,
    fillRule: "evenodd",
    d: "M13 9v1.5a.5.5 0 0 1-1 0V9h-1.5a.5.5 0 0 1 0-1H12V6.5a.5.5 0 0 1 1 0V8h1.5a.5.5 0 0 1 0 1H13zm-.5 15a.501.501 0 0 1-.327-.122C11.839 23.59 4 16.718 4 8.5 4 3.813 7.813 0 12.5 0 17.187 0 21 3.813 21 8.5c0 8.218-7.839 15.09-8.173 15.378A.501.501 0 0 1 12.5 24zm0-23C8.364 1 5 4.364 5 8.5c0 6.842 6.016 12.926 7.5 14.322C13.983 21.425 20 15.334 20 8.5 20 4.364 16.636 1 12.5 1zm0 13A5.506 5.506 0 0 1 7 8.5C7 5.467 9.468 3 12.5 3S18 5.467 18 8.5 15.532 14 12.5 14zm0-10A4.505 4.505 0 0 0 8 8.5c0 2.481 2.019 4.5 4.5 4.5S17 10.981 17 8.5 14.981 4 12.5 4z"
  }));
};

LocationAdd.displayName = 'LocationAdd';

var copyDictionary$4 = {
  en: {
    a11yText: 'Location eligible'
  },
  fr: {
    a11yText: 'Emplacement admissible'
  }
};

var LocationSuccess = function LocationSuccess(props) {
  return React.createElement(FeedbackIcon, _extends_1({}, props, {
    copyDictionary: copyDictionary$4,
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }), React.createElement("path", {
    fill: colorAccessibleGreen,
    fillRule: "evenodd",
    d: "M12.5 24a.501.501 0 0 1-.327-.122C11.839 23.59 4 16.718 4 8.5 4 3.813 7.813 0 12.5 0 17.187 0 21 3.813 21 8.5c0 8.218-7.839 15.09-8.173 15.378A.501.501 0 0 1 12.5 24zm0-23C8.364 1 5 4.364 5 8.5c0 6.842 6.016 12.926 7.5 14.322C13.983 21.425 20 15.334 20 8.5 20 4.364 16.636 1 12.5 1zm0 13A5.506 5.506 0 0 1 7 8.5C7 5.467 9.468 3 12.5 3S18 5.467 18 8.5 15.532 14 12.5 14zm0-10A4.505 4.505 0 0 0 8 8.5c0 2.481 2.019 4.5 4.5 4.5S17 10.981 17 8.5 14.981 4 12.5 4zm-1 7a.502.502 0 0 1-.354-.146l-2-2a.5.5 0 0 1 .707-.707L11.5 9.793l3.646-3.646a.5.5 0 0 1 .707.707l-4 4A.498.498 0 0 1 11.5 11z"
  }));
};

LocationSuccess.displayName = 'LocationSuccess';

var copyDictionary$5 = {
  en: {
    a11yText: 'Location not eligible'
  },
  fr: {
    a11yText: 'Emplacement non admissible'
  }
};

var LocationIneligible = function LocationIneligible(props) {
  return React.createElement(FeedbackIcon, _extends_1({}, props, {
    copyDictionary: copyDictionary$5,
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }), React.createElement("path", {
    fill: colorCardinal,
    fillRule: "evenodd",
    d: "M12.5 9.207l-1.647 1.647a.498.498 0 0 1-.707 0 .5.5 0 0 1 0-.707l1.646-1.646-1.646-1.647a.5.5 0 0 1 .707-.707l1.646 1.646 1.647-1.646a.5.5 0 0 1 .707.707l-1.646 1.647 1.646 1.646a.5.5 0 0 1-.707.707l-1.647-1.646zM12.5 24a.501.501 0 0 1-.327-.122C11.839 23.59 4 16.718 4 8.5 4 3.813 7.813 0 12.5 0 17.187 0 21 3.813 21 8.5c0 8.218-7.839 15.09-8.173 15.378A.501.501 0 0 1 12.5 24zm0-23C8.364 1 5 4.364 5 8.5c0 6.842 6.016 12.926 7.5 14.322C13.983 21.425 20 15.334 20 8.5 20 4.364 16.636 1 12.5 1zm0 13A5.506 5.506 0 0 1 7 8.5C7 5.467 9.468 3 12.5 3S18 5.467 18 8.5 15.532 14 12.5 14zm0-10A4.505 4.505 0 0 0 8 8.5c0 2.481 2.019 4.5 4.5 4.5S17 10.981 17 8.5 14.981 4 12.5 4z"
  }));
};

LocationIneligible.displayName = 'LocationIneligible';

export { Checkmark, LocationAdd, LocationIneligible, LocationSuccess, NotificationError, NotificationSuccess, NotificationWarning, Times };
